export default __webpack_public_path__ + "static/media/settings-add.fde75d0e.svg";